import React, { Component } from "react";
import cookie from "react-cookies";
import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  isValidPrice,
  isNumber,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
var module = "products";
var moduleName = "Product";
var modulePath = "/clientpanel/catalog-products";
var dayList = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (
      this.props.match.path === "/clientpanel/catalog-products/edit/:EditID"
    ) {
      editID = this.props.match.params.EditID;
    }
    var allowOutlet = cookie.load("clientAllowOutlet") ?? '';
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        productOutletID:[],
        productType: "",
        productCategoryID: "",
        productAvailabilityID: [],
        productName: "",
        productAliasName: "",
        productSKU: "",
        productPOSID: "",
        productTagInfo: "",
        productMinimumQuantity: "",
        productMaximumQuantity: "",
        productSequence: "",
        productMetaTitle: "",
        productMetaKeywords: "",
        productMetaDescription: "",
        productLeadTime: "",
        productShortDescription: "",
        productLongDescription: "",
        productTag: [],
        productPrice: "",
        productCost: "",
        productSpecialPrice: "",
        productSpecialPriceStart: "",
        productSpecialPriceEnd: "",
        productStock: "",
        productThumbnail: "",
        productLargeImage:"",
        productGallery: [],
        productApplyMinMaxSelect: false,
        productComboSet: [
          {
            combo_name: "",
            products: [],
            defaultproduct: "",
            combogroup: [],
            min_select: "0",
            max_select: "0",
            sequence: 1,
            piecescount: "0",
            apply_price: false,
            apply_modifier: false,
            multipleselection_apply: false,
            single_selection:false,
          },
        ],
        productTimeAvailability: [
          {
            title: "Current day(date) and time based product availability",
            type: "currentdate",
            data: [
              {
                daybased: [
                  { day: "", from: "", to: "", stock: "", validate: "" },
                ],
              },
              { datebased: [{ from: "", to: "", stock: "", validate: "" }] },
            ],
          },
          {
            title: "Fullfillment day(date) and time based product availability",
            type: "fullfillmentdate",
            data: [
              {
                daybased: [
                  { day: "", from: "", to: "", stock: "", validate: "" },
                ],
              },
              { datebased: [{ from: "", to: "", stock: "", validate: "" }] },
            ],
          },
        ],
        productTimeAvailabilityErrorInfo: "",
        productStatus: "",
        productVoucherType: "",
        productVoucherExpiryDate: "",
        productVoucherExpiryDays: "",
        productVoucherReedmedAvailability: "",
        productVoucherFoodOption: "",
        productVoucherPoints: "",
        productVoucherIncreaseQTY: "",
        productVoucherFoodDiscountType: "",
        productFoodVoucherDiscValue: "",
        productVoucherFreeProduct: "",
        productVoucherValidateProducts: [],
       
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      availabiltyList: [],
      availability: [],
      formpost: [],
      companyDetail: [],
      outletList: [],
      productTypeList: [],
      subcategoryList: [],
      simpleProducts: [],
      prdouctGroupList: [],
      productTagList: [],
      listProductSetup: [],
      allowOutlet: allowOutlet,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    this.loadproductTypeList();
    this.loadAvailabilty();
    this.listProductSetup();
    this.loadSubcategory();
    this.laodSimpleProducts();
    this.laodproductTagList();
    this.laodprdouctGroupList();
    
    if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var productStatus = result.productStatus === "A" ? "Active" : "In Active";
          var status =
            result.productStatus !== "" && result.productStatus !== null
              ? {
                  label: productStatus,
                  value: result.productStatus,
                }
              : "";

          let productVoucherType = "";
          if (result.productVoucherType === "f") {
            productVoucherType = { label: "Food Voucher", value: "f" };
          } else if (result.productVoucherType === "c") {
            productVoucherType = { label: "Cash Voucher", value: "c" };
          }
          var productVoucherFoodOption = "";
          if (result.productVoucherFoodOption === "1") {
            productVoucherFoodOption = { label: "Normal", value: "1" };
          } else if (result.productVoucherFoodOption === "2") {
            productVoucherFoodOption = { label: "Discount", value: "2" };
          }
          var productVoucherFoodDiscountType = "";
          if (result.productVoucherFoodDiscountType === "1") {
            productVoucherFoodDiscountType = {
              label: "Normal",
              value: "1",
            };
          } else if (result.productVoucherFoodDiscountType === "2") {
            productVoucherFoodDiscountType = {
              label: "Discount",
              value: "2",
            };
          }

          var clientupdatedata = {
            productOutletID: result?.productOutletID ?? [],
            productType: result.productType,
            productCategoryID: result.subcategory ?? "",
            productAvailabilityID:result?.productAvailabilityID ?? [],
            productName: result.productName,
            productAliasName: result.productAliasName,
            productSKU: result.productSKU,
            productPOSID: result.productPOSID,
            productTagInfo: result.productTagInfo,
            productMinimumQuantity: result.productMinimumQuantity,
            productMaximumQuantity: result.productMaximumQuantity,
            productSequence: result.productSequence,
            productShortDescription: result.productShortDescription,
            productLongDescription: result.productLongDescription,            
            productMetaTitle: result.productMetaTitle,
            productMetaKeywords: result.productMetaKeywords,
            productMetaDescription: result.productMetaDescription,
            productPrice: result.productPrice,
            productCost: result.productCost,
            productSpecialPrice: result.productSpecialPrice,
            productSpecialPriceStart: result.productSpecialPriceStart !== "" && result.productSpecialPriceStart!==null ? new Date(result.productSpecialPriceStart): "",
            productSpecialPriceEnd:result.productSpecialPriceEnd !== "" && result.productSpecialPriceEnd!==null ? new Date(result.productSpecialPriceEnd): "",
            productStock: result.productStock!=="" && result.productStock!==null ? JSON.parse(result.productStock) : '',
            productThumbnail: result.productThumbnail !== "" && result.productThumbnail !== null ? result.productThumbnail
            : "",
            productLargeImage: result?.productLargeImage ?? "",
            productGallery:
              result.productGallery !== "" && result.productGallery !== null
                ? result.productGallery.split(",")
                : [],
            productComboSet:result.productComboSet!=="" && result.productComboSet!==null ? JSON.parse(result.productComboSet) : this.state.clientdata.productComboSet,              
            productTimeAvailability: result.productTimeAvailability!=="" && result.productTimeAvailability!==null ? JSON.parse(result.productTimeAvailability) : this.state.clientdata.productTimeAvailability,

            productApplyMinMaxSelect: result?.productApplyMinMaxSelect ?? false,            
            productTimeAvailabilityErrorInfo: result.productTimeAvailabilityErrorInfo,
            productVoucherType: productVoucherType,
            productVoucherExpiryDate: result.productVoucherExpiryDate !== "" && result.productVoucherExpiryDate !== null ? new Date(result.productVoucherExpiryDate) : "",
            productVoucherExpiryDays: result.productVoucherExpiryDays,
            productVoucherReedmedAvailability: result.productVoucherReedmedAvailability,
            productVoucherFoodOption: productVoucherFoodOption,
            productVoucherPoints: result.productVoucherPoints,
            productVoucherIncreaseQTY:result.productVoucherIncreaseQTY,                
            productVoucherFoodDiscountType: productVoucherFoodDiscountType,
            productFoodVoucherDiscValue: result.productFoodVoucherDiscValue,
            productVoucherFreeProduct: result.productVoucherFreeProduct,
            productVoucherValidateProducts: result.productVoucherValidateProducts ?? [],
            productTag: result.productTag,
            productStatus: status
          };
          this.setState(
            { clientdata: clientupdatedata, pageloading: false },
            () => {
             /*  this.loadSubcategory();
              this.laodSimpleProducts();
              this.laodprdouctGroupList();
              this.laodproductTagList(); */
            }
          );
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  listProductSetup() {
    /* var urlShringTxt = apiUrl + module+ "/dropSimpleDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ listProductSetup: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    }); */
  }

  loadproductTypeList() {
    var urlShringTxt = apiUrl + "common/getProductType" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ productTypeList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });    
  }
  laodSimpleProducts() {
    var urlShringTxt = apiUrl + module+ "/dropSimpleDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ simpleProducts: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  laodprdouctGroupList() {
    var urlShringTxt = apiUrl + "product-group/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ prdouctGroupList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
    /* var storeID = this.state.clientdata.productOutletID?.value || "";
    if (storeID !== "") {
      var urlShringTxt =
        apiUrl +
        "clientpanel/productgroup/dropdownlist?company_id=" +
        CompanyID() +
        "&storeID=" +
        storeID;
      axios.get(urlShringTxt, clientheaderconfig).then((res) => {
        if (res.data.status === "ok") {
          var resultSet = res.data.result;
          this.setState({ prdouctGroupList: resultSet });
        }
      });
    } */
  }

  loadSubcategory() {
    
    var urlShringTxt = apiUrl + "subcategory/dropDownCatSubCat";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        const result = this.getFlattenedOptions(res.data.result);
        this.setState({ subcategoryList: result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  getFlattenedOptions (data)  {
    return data.map(category => ({
      label: category.label, // Main category label
      value:category._id,
      options: category.options.map(option => ({
        ...option,
        parentId: category._id // Attach parent _id
      }))
    }));
  };

  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  laodproductTagList() {
    var urlShringTxt = apiUrl + "producttag/dropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ productTagList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    console.log("Parent _id:", value?.parentId);
    console.log(field, value, 'valuevalue')
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var productType =  postData.productType?.value ?? 1;


    let productOutletID = postData.productOutletID.length > 0 ? postData.productOutletID.map(item => item.value) : [];
    let productAvailabilityID = postData.productAvailabilityID.length > 0 ? postData.productAvailabilityID.map(item => item.value) : [];
    let productTag = postData.productTag.length > 0 ? postData.productTag.map(item => item.value) : [];
    let productStock = [];
    if(postData.productStock!==null && postData.productStock!=="" ){
      if(postData.productStock.length>0) {
        postData.productStock.map((item)=> {
          if(productOutletID.indexOf(item.outletID)>=0) {
            productStock.push(item);
          }
        })
      }
    }

    let postObject = {
      productOutletID:productOutletID.length > 0 ? productOutletID.join(",") : "",
      productType: productType,
      productAvailabilityID:productAvailabilityID.length > 0 ? productAvailabilityID.join(",") : "",
      productName: postData.productName,
      productAliasName: postData.productAliasName,
      productSKU: postData.productSKU,
      productPOSID: postData.productPOSID,
      productTagInfo: postData.productTagInfo,
      productCategoryID: postData.productCategoryID?.parentId ?? "",
      productSubCategoryID: postData.productCategoryID?.value ?? "",
      productShortDescription: postData.productShortDescription,
      productLongDescription: postData.productLongDescription,
      productMinimumQuantity: postData.productMinimumQuantity,
      productMaximumQuantity: postData.productMaximumQuantity,
      productSequence: postData.productSequence,
      productMetaTitle: postData.productMetaTitle,
      productMetaKeywords: postData.productMetaKeywords,
      productMetaDescription: postData.productMetaDescription,
      productLeadTime: postData.productLeadTime,
      productTag:productTag.length > 0 ? productTag.join(",") : "",
      productPrice: postData.productPrice,
      productCost: postData.productCost,
      productSpecialPrice: postData.productSpecialPrice,
      productSpecialPriceStart:postData.productSpecialPriceStart,
      productSpecialPriceEnd: postData.productSpecialPriceEnd,
      productStock: (productStock.length>0)?JSON.stringify(productStock):'',
      productThumbnail: postData.productThumbnail,
      productLargeImage: postData.productLargeImage,
      productGallery: postData.productGallery.length > 0 ? postData.productGallery.join(",") : "",
      productApplyMinMaxSelect:postData.productApplyMinMaxSelect,
      productComboSet: productType === 2 ? JSON.stringify(postData.productComboSet) : "",
      productTimeAvailability: JSON.stringify(postData.productTimeAvailability),
      productTimeAvailabilityErrorInfo: postData.productTimeAvailabilityErrorInfo,
      productStatus:  postData.productStatus?.value ?? "A",      
    };

    if(productType === 3) {
      const productVoucherReedmedAvailability = postData.productVoucherReedmedAvailability.length > 0 ? postData.productVoucherReedmedAvailability.map(item => item.value) : [];

      const productVoucherFoodOption = postData.productVoucherFoodOption?.value ?? '';

      const productVoucherValidateProducts = postData.productVoucherValidateProducts.length > 0 ? postData.productVoucherValidateProducts.map(item => item.value) : [];
    
      

      postObject.productVoucherType = postData.productVoucherType?.value ?? '';;
      postObject.productVoucherExpiryDate =  postData.productVoucherExpiryDate;
      postObject.productVoucherExpiryDays = postData.productVoucherExpiryDays;
      postObject.productVoucherReedmedAvailability = productVoucherReedmedAvailability.length > 0 ? productVoucherReedmedAvailability.join(",") : "";
      postObject.productVoucherFoodOption = productVoucherFoodOption;
      postObject.productVoucherPoints =  postData.productVoucherPoints;
      postObject.productVoucherIncreaseQTY =  postData.productVoucherIncreaseQTY;
      postObject.productVoucherFoodDiscountType = postData.productVoucherFoodDiscountType?.value ?? '';
      postObject.productFoodVoucherDiscValue =  productVoucherFoodOption === "2"  ? postData.productFoodVoucherDiscValue : "";
      postObject.productVoucherFreeProduct =  postData.productVoucherFreeProduct?.value ?? "";
      postObject.productVoucherValidateProducts = productVoucherFoodOption === "2" ? productVoucherValidateProducts.length > 0 ? productVoucherValidateProducts.join(",") : "" : "";
      
     
    }

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-products"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  outletList={this.state.outletList}
                  availabiltyList={this.state.availabiltyList}
                  productTypeList={this.state.productTypeList}
                  subcategoryList={this.state.subcategoryList}
                  simpleProducts={this.state.simpleProducts}
                  prdouctGroupList={this.state.prdouctGroupList}
                  productTagList={this.state.productTagList}
                  listProductSetup={this.state.listProductSetup}
                  allowOutlet={this.state.allowOutlet}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { productType, productCategoryID, productName, productSKU, productPrice, productCost, productSpecialPrice, productStock, productStatus } = props.fields;

  return {
    fields: ["productType", "productCategoryID", "productName", "productSKU", "productPrice", "productCost", "productSpecialPrice", "productStock", "productStatus" ],

    validations: {
      productType: [[isSingleSelect, productType]],
      productCategoryID: [[isSingleSelect, productCategoryID]],
      productName: [[isEmpty, productName]],
      productSKU: [[isEmpty, productSKU]],
      productPrice: [
        [isEmpty, productPrice],
        [isValidPrice, productPrice],
      ],
      productCost: [[isValidPrice, productCost]],
      productSpecialPrice: [[isValidPrice, productSpecialPrice]],
      productStock: [
        [isCheckingStock, productStock],
      ],
      productStatus: [[isSingleSelect, productStatus]],
    },
  };
}

const isCheckingStock = () => {

}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
    this.setLongContent = this.setLongContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("productShortDescription", value);
  }
  setLongContent(value) {
    this.props.onChange("productLongDescription", value);
  }
  handleChangeCheck(name, event) {
    var value = event.target.checked;
    this.props.onChange(name, value);
  }

  handleChangeCheckBox(type, dayIndex, typebase, elementType, event) {
    this.updateDayAvail(type, dayIndex, typebase, elementType, event.target.value, event.target.checked);
  }
  handleChangeAvailDate(type, dayIndex, typebase, elementType, selectDate) {
    this.updateDayAvail(type, dayIndex, typebase, elementType, selectDate);
  }
  handleChangeText(type, dayIndex, typebase, elementType, event) {
    this.updateDayAvail(type, dayIndex, typebase, elementType, event.target.value);
  }
  myFilter(elm) {
    return elm != null && elm !== false && elm !== "";
  }

  updateDayAvail(type, dayIndex, typebase, elementType, value, checkedStatus = null) {
    var productTimeAvailability = this.props.fields.productTimeAvailability;
    var updatedproductTimeAvailability = [];
    productTimeAvailability.map((item) => {
      if (item.type === type) {
        var updateData = [];
        var daybased = item.data[0].daybased;
        var datebased = item.data[1].datebased;
        if (typebase === "daybased") {
          var updatedDayBase = [];
          daybased.map((dayItems, dayItemIndex) => {
            var updday = dayItems.day;
            var updfrom = dayItems.from;
            var updto = dayItems.to;
            var updstock = dayItems.stock;
            var updvalidate = dayItems.validate;
            if (dayIndex === dayItemIndex) {
              if (elementType === "day") {
                var splitupdday = updday.split(",").filter(this.myFilter);
                if (checkedStatus === true) {
                  splitupdday.push(value);
                } else {
                  const index = splitupdday.indexOf(value);
                  splitupdday.splice(index, 1);
                }
                updday = splitupdday.length > 0 ? splitupdday.join(",") : "";
              } else if (elementType === "fromtime") {
                updfrom = value;
              } else if (elementType === "totime") {
                updto = value;
              } else if (elementType === "stock") {
                updstock = value;
              } else if (elementType === "validate") {
                if (checkedStatus === true) {
                  updvalidate = value;
                } else {
                  updvalidate = "";
                }
              }
            }
            updatedDayBase.push({
              day: updday,
              from: updfrom,
              to: updto,
              stock: updstock,
              validate: updvalidate,
            });
            return "";
          });
          daybased = updatedDayBase;
        }
        if (typebase === "datebased") {
          var updatedDateBase = [];
          datebased.map((dateItems, dateItemIndex) => {
            var updfrom = dateItems.from;
            var updto = dateItems.to;
            var updstock = dateItems.stock;
            var updvalidate = dateItems.validate;
            if (dayIndex === dateItemIndex) {
              if (elementType === "fromdate") {
                updfrom = value;
              } else if (elementType === "todate") {
                updto = value;
              } else if (elementType === "stock") {
                updstock = value;
              } else if (elementType === "validate") {
                if (checkedStatus === true) {
                  updvalidate = value;
                } else {
                  updvalidate = "";
                }
              }
            }
            updatedDateBase.push({
              from: updfrom,
              to: updto,
              stock: updstock,
              validate: updvalidate,
            });
            return "";
          });
          datebased = updatedDateBase;
        }
        updateData.push({ daybased: daybased }, { datebased: datebased });
        updatedproductTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedproductTimeAvailability.push(item);
      }
      return '';
    });
    this.props.onChange("productTimeAvailability", updatedproductTimeAvailability);
  }

  addNew(selectIndex, type) {
    var productTimeAvailability = this.props.fields.productTimeAvailability;
    var updatedproductTimeAvailability = [];
    productTimeAvailability.map((item, index) => {
      if (index === selectIndex) {
        var updateData = [];
        var daybased = item.data[0].daybased;
        var datebased = item.data[1].datebased;
        if (type === "daybased") {
          daybased.push({
            day: "",
            from: "",
            to: "",
            stock: "",
            validate: "",
          });
        } else if (type === "datebased") {
          datebased.push({
            from: "",
            to: "",
            stock: "",
            validate: "",
          });
        }
        updateData.push({ daybased: daybased }, { datebased: datebased });
        updatedproductTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedproductTimeAvailability.push(item);
      }
      return "";
    });
    this.props.onChange("productTimeAvailability", updatedproductTimeAvailability);
  }

  addNewCombo() {
    var productComboSet = this.props.fields.productComboSet;
    productComboSet.push({
      productComboSet: "",
      products: [],
      defaultproduct: "",
      combogroup: [],
      min_select: "0",
      max_select: "0",
      sequence: parseInt(this.props.fields.productComboSet.length) + 1,
      piecescount: "0",
      apply_price: false,
      apply_modifier: false,
      multipleselection_apply: false,
      single_selection: false,
    });
    this.props.onChange("productComboSet", productComboSet);
  }
  removeComboSet(removeIndex) {
    var productComboSet = this.props.fields.productComboSet;
    var newcomosetup = [];
    productComboSet.map((item, index) => {
      if (removeIndex !== index) {
        newcomosetup.push(item);
      }
      return "";
    });
    this.props.onChange("productComboSet", newcomosetup);
  }
  handleChangeComboTxt(updIndex, updKey, event) {
    this.updateCombSet(updIndex, updKey, event.target.value);
  }
  handleChangeComboSelect(updIndex, updKey, value) {
    this.updateCombSet(updIndex, updKey, value);
  }
  handleChangeComboCheck(updIndex, updKey, event) {
    var value = event.target.checked;
    console.log(value, 'valuevaluevalue')
    this.updateCombSet(updIndex, updKey, value);
  }
  updateCombSet(updIndex, updKey, updValue) {
    var como_setup = this.props.fields.productComboSet;
    var updateComboSet = [];
    como_setup.map((item, index) => {
      if (index === updIndex) {
        var combo_name = item.combo_name;
        var products = item.products;
        var defaultproduct = item.defaultproduct;
        var combogroup = item.combogroup;
        var min_select = item.min_select;
        var max_select = item.max_select;
        var sequence = item.sequence;
        var piecescount = item.piecescount;
        var apply_price = item.apply_price;
        var apply_modifier = item.apply_modifier;
        var multipleselection_apply = item.multipleselection_apply;
        var single_selection = item.single_selection;
        if (updKey === "combo_name") {
          combo_name = updValue;
        } else if (updKey === "products") {
          products = updValue;
        } else if (updKey === "defaultproduct") {
          defaultproduct = updValue;
        } else if (updKey === "combogroup") {
          combogroup = updValue;
        } else if (updKey === "min_select") {
          min_select = updValue;
        } else if (updKey === "max_select") {
          max_select = updValue;
        } else if (updKey === "sequence") {
          sequence = updValue;
        } else if (updKey === "piecescount") {
          piecescount = updValue;
        } else if (updKey === "apply_price") {
          apply_price = updValue;
        } else if (updKey === "apply_modifier") {
          apply_modifier = updValue;
        } else if (updKey === "multipleselection_apply") {
          multipleselection_apply = updValue;
        } else if (updKey === "single_selection") {
          single_selection = updValue;
        }
        console.log(multipleselection_apply, 'multipleselection_apply')
        updateComboSet.push({
          combo_name: combo_name,
          products: products,
          defaultproduct: defaultproduct,
          combogroup: combogroup,
          min_select: min_select,
          max_select: max_select,
          sequence: sequence,
          piecescount: piecescount,
          apply_price: apply_price,
          apply_modifier: apply_modifier,
          multipleselection_apply: multipleselection_apply,
          single_selection: single_selection,
        });
      } else {
        updateComboSet.push(item);
      }
      return "";
    });
    this.props.onChange("productComboSet", updateComboSet);
  }

  async uplaodGalleryImage() {
    this.props.sateValChange("btndisabled", true);
    var imagefile = document.querySelector("#gallery_images");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "products", "client");
    if (fileDetail.status === "ok") {
      var productGallery = this.props.fields.productGallery;
      productGallery.push(fileDetail.url);
      this.props.onChange("productGallery", productGallery);
    }
    $("#gallery_images").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeGalleryImage(fileNamme, removeIndex) {
    showLoader("galleryDetails_".removeIndex);
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader("galleryDetails_".removeIndex);
      var productGallery = this.props.fields.productGallery;
      productGallery.splice(removeIndex, 1);
      this.props.onChange("productGallery", productGallery);
    }
  }

  async uplaodFiles(imageType) {
    this.props.sateValChange("btndisabled", true);
    alert(imageType);
    if(imageType==='productThumbnail') {
      showLoader("ImageDetails");
      showLoader("ImageContainer");
    }else {
      showLoader("LargeImageDetails");
      showLoader("LargeImageContainer");
    }
    
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "products", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    if(imageType==='productThumbnail') {
      hideLoader("ImageContainer");
      hideLoader("ImageDetails");
    }else {
      hideLoader("LargeImageContainer");
      hideLoader("LargeImageDetails");      
    }
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType) {
    if(imageType==='productThumbnail') {
      showLoader("ImageDetails", "class");
    }else {
      showLoader("LargeImageDetails", "class");
    }
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      if(imageType==='productThumbnail') {
        hideLoader("ImageDetails", "class");
      }else {
        hideLoader("LargeImageDetails", "class");
      }
      this.props.onChange(imageType, "");
    }
  }

  deleteAvailSlot(avilindex, avildayIndex, type) {
    let productTimeAvailability = this.props.fields.productTimeAvailability;

    let getAvil = productTimeAvailability[avilindex];
    if (type === "daybased") {
      let updItem = [];
      getAvil.data[0].daybased.map((dayItem, dayIndex) => {
        if (dayIndex !== avildayIndex) {
          updItem.push(dayItem);
        }
        return '';
      });
      getAvil.data[0].daybased = updItem;
    }
    if (type === "datebased") {
      let updItem_ = [];
      getAvil.data[1].datebased.map((dayItem, dayIndex) => {
        if (dayIndex !== avildayIndex) {
          updItem_.push(dayItem);
        }
        return '';
      });
      getAvil.data[1].datebased = updItem_;
    }
    productTimeAvailability[avilindex] = getAvil;
    this.props.onChange("productTimeAvailability", productTimeAvailability);
  }

  handleChangeStockTxt(outletID, updKey, event) {
    const value = event.target.type==="checkbox" ?event.target.checked:event.target.value 
    console.log(outletID,updKey, event.target.type, event.target.value, 'outletID');
    this.updateStock(outletID, updKey, value)
   // this.updateCombSet(updIndex, updKey, event.target.value);
  }

  updateStock(outletID, updKey, value) {
    let existOutlet = false;

    let updatedStock = Array.isArray(this.props.fields.productStock)
      ? this.props.fields.productStock.map((acc) => {
          const stockoutletID = acc?.outletID ?? '';
          if (outletID === stockoutletID) {
            existOutlet = true;
            return {
              ...acc,
              stock: updKey === 'stock' ? value : acc.stock,
              lowStockAlert: updKey === 'lowStockAlert' ? value : acc.lowStockAlert,
              outofStock: updKey === 'outofStock' ? value : acc.outofStock,
              lowStock: updKey === 'lowStock' ? value : acc.lowStock,
            };
          }
          return acc;
        })
      : [];
    
    if (!existOutlet) {
      const newStock = {
        outletID,
        stock: updKey === 'stock' ? value : '',
        lowStockAlert: updKey === 'lowStockAlert' ? value : false,
        outofStock: updKey === 'outofStock' ? value : false,
        lowStock: updKey === 'lowStock' ? value : '',
      };
    
      updatedStock.push(newStock);
    }
   console.log(updatedStock, 'updatedStock')
   this.props.onChange("productStock", updatedStock);
    
  }


  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgProductType,
      errMsgCategory,
      errMsgProName,
      errMsgsku,
      errMsgStatus,
      errMsgProPrice,
      errMsgProCost,
      errMsgProSpecialPrice,
      errMsgProStock = "";
    if ($validation.productType.error.reason !== undefined) {
      errMsgProductType = $validation.productType.show && (
        <span className="error">{$validation.productType.error.reason}</span>
      );
    }
    if ($validation.productCategoryID.error.reason !== undefined) {
      errMsgCategory = $validation.productCategoryID.show && (
        <span className="error">{$validation.productCategoryID.error.reason}</span>
      );
    }
    if ($validation.productName.error.reason !== undefined) {
      errMsgProName = $validation.productName.show && (
        <span className="error">{$validation.productName.error.reason}</span>
      );
    }
    if ($validation.productSKU.error.reason !== undefined) {
      errMsgsku = $validation.productSKU.show && (
        <span className="error">{$validation.productSKU.error.reason}</span>
      );
    }
    if ($validation.productPrice.error.reason !== undefined) {
      errMsgProPrice = $validation.productPrice.show && (
        <span className="error">{$validation.productPrice.error.reason}</span>
      );
    }
    if ($validation.productCost.error.reason !== undefined) {
      errMsgProCost = $validation.productCost.show && (
        <span className="error">{$validation.productCost.error.reason}</span>
      );
    }
    if ($validation.productSpecialPrice.error.reason !== undefined) {
      errMsgProSpecialPrice = $validation.productSpecialPrice.show && (
        <span className="error">{$validation.productSpecialPrice.error.reason}</span>
      );
    }
    if ($validation.productStock.error.reason !== undefined) {
      errMsgProStock = $validation.productStock.show && (
        <span className="error">{$validation.productStock.error.reason}</span>
      );
    }

    if ($validation.productStatus.error.reason !== undefined) {
      errMsgStatus = $validation.productStatus.show && (
        <span className="error">{$validation.productStatus.error.reason}</span>
      );
    }
    var productType = fields.productType?.value ?? 1;
 

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="row g-3">
          <div
            className="accordion mt-3 accordion-header-primary"
            id="accordionStyle1"
          >
            <div className="accordion-item active">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionStyle1-3"
                  aria-expanded="true"
                >
                  General Info
                </button>
              </h2>
              <div
                id="accordionStyle1-3"
                className="accordion-collapse collapse show  mt-3"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    {this.props.allowOutlet === "" && (
                      <div
                        className="col-md-6"
                      >
                        <div className="form-floating form-floating-outline custm-select-box mb-4">
                          <Select
                            value={fields.productOutletID}
                            onChange={this.handleSelectChange.bind(
                              this,
                              "productOutletID"
                            )}
                            placeholder={"Select Outlet"}
                            options={this.props.outletList}
                            isClearable={true}
                            isMulti
                          />
                          <label className="select-box-label">
                            Outlet
                          </label>
                        </div>
                      </div>
                    )}
                    <div
                      className={
                        errMsgProductType !== "" &&
                        errMsgProductType !== false &&
                        errMsgProductType !== undefined
                          ? "col-md-6 error-select error"
                          : "col-md-6"
                      }
                    >
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productType}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "productType"
                          )}
                          placeholder={"Select Product Type"}
                          options={this.props.productTypeList}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Product Type<span className="error">*</span>
                        </label>
                        {errMsgProductType}
                      </div>
                    </div>
                    <div
                      className={
                        errMsgCategory !== "" &&
                        errMsgCategory !== false &&
                        errMsgCategory !== undefined
                          ? "col-md-6 error-select error"
                          : "col-md-6"
                      }
                    >
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productCategoryID}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "productCategoryID"
                          )}
                          placeholder={"Select Sub Category"}
                          options={
                            this.props.subcategoryList.length > 0
                              ? this.props.subcategoryList
                              : []
                          }
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Sub Category<span className="error">*</span>
                        </label>
                        {errMsgCategory}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productAvailabilityID}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "productAvailabilityID"
                          )}
                          isMulti
                          placeholder="Select Availabilty"
                          options={this.props.availabiltyList}
                          isClearable={true}
                        />
                        <label className="select-box-label">Availabilty</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgProName !== "" &&
                            errMsgProName !== false &&
                            errMsgProName !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="productName"
                          value={fields.productName}
                          {...$field("productName", (e) =>
                            onChange("productName", e.target.value)
                          )}
                        />
                        <label htmlFor="productName">
                          Product Name <span className="error">*</span>
                        </label>
                        {errMsgProName}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productAliasName"
                          value={fields.productAliasName}
                          {...$field("productAliasName", (e) =>
                            onChange("productAliasName", e.target.value)
                          )}
                        />
                        <label htmlFor="productAliasName">Alias Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgsku !== "" &&
                            errMsgsku !== false &&
                            errMsgsku !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="productSKU"
                          value={fields.productSKU}
                          {...$field("productSKU", (e) =>
                            onChange("productSKU", e.target.value)
                          )}
                        />
                        <label htmlFor="productSKU">
                          SKU <span className="error">*</span>
                        </label>
                        {errMsgsku}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productTagInfo"
                          value={fields.productTagInfo}
                          {...$field("productTagInfo", (e) =>
                            onChange("productTagInfo", e.target.value)
                          )}
                        />
                        <label htmlFor="productTagInfo">Tag Info</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productMinimumQuantity"
                          value={fields.productMinimumQuantity}
                          {...$field("productMinimumQuantity", (e) =>
                            onChange("productMinimumQuantity", e.target.value)
                          )}
                        />
                        <label htmlFor="productMinimumQuantity">Minimum Quantity</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productMaximumQuantity"
                          value={fields.productMaximumQuantity}
                          {...$field("productMaximumQuantity", (e) =>
                            onChange("productMaximumQuantity", e.target.value)
                          )}
                        />
                        <label htmlFor="productMaximumQuantity">Maximum Quantity</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productSequence"
                          value={fields.productSequence}
                          {...$field("productSequence", (e) =>
                            onChange("productSequence", e.target.value)
                          )}
                        />
                        <label htmlFor="productSequence">Sequence</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productPOSID"
                          value={fields.productPOSID}
                          {...$field("productPOSID", (e) =>
                            onChange("productPOSID", e.target.value)
                          )}
                        />
                        <label htmlFor="productPOSID">POS ID</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productMetaTitle"
                          value={fields.productMetaTitle}
                          {...$field("productMetaTitle", (e) =>
                            onChange("productMetaTitle", e.target.value)
                          )}
                        />
                        <label htmlFor="productMetaTitle">Meta Title</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <textarea
                          className="form-control h-px-75"
                          id="productMetaKeywords"
                          name="meta_keproductMetaKeywordsywords"
                          placeholder="Meta Keywords"
                          rows="3"
                          {...$field("productMetaKeywords", (e) =>
                            onChange("productMetaKeywords", e.target.value)
                          )}
                          value={fields.productMetaKeywords}
                        >
                          {fields.productMetaKeywords}
                        </textarea>
                        <label htmlFor="productMetaKeywords">Meta Keywords</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <textarea
                          className="form-control h-px-75"
                          id="productMetaDescription"
                          name="productMetaDescription"
                          placeholder="Meta Description"
                          value={fields.productMetaDescription}
                          rows="3"
                          {...$field("productMetaDescription", (e) =>
                            onChange("productMetaDescription", e.target.value)
                          )}
                        ></textarea>
                        <label htmlFor="productMetaDescription">
                          Meta Description
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productLeadTime"
                          value={fields.productLeadTime}
                          {...$field("productLeadTime", (e) =>
                            onChange("productLeadTime", e.target.value)
                          )}
                        />
                        <label htmlFor="productLeadTime">Lead Time</label>
                      </div>
                    </div>                    
                    <div className="col-md-12">
                      <label>Short Description</label>
                      <Editor
                        setContent={this.setContent}
                        data={fields.productShortDescription}
                      />
                    </div>
                    <div className="col-md-12">
                      <label>Login Description</label>
                      <Editor
                        setContent={this.setLongContent}
                        data={fields.productLongDescription}
                      />
                    </div>

                    <div className="col-md-12">
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productTag}
                          isMulti
                          onChange={this.handleSelectChange.bind(
                            this,
                            "productTag"
                          )}
                          placeholder="Select Tags"
                          options={this.props.productTagList}
                          isClearable={true}
                        />
                        <label className="select-box-label">Tags</label>
                      </div>
                    </div>
                    <div
                      className={
                        errMsgStatus !== "" &&
                        errMsgStatus !== false &&
                        errMsgStatus !== undefined
                          ? "col-md-6 error-select error"
                          : "col-md-6"
                      }
                    >
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productStatus}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "productStatus"
                          )}
                          placeholder="Select Status"
                          options={[
                            { value: "A", label: "Active" },
                            { value: "I", label: "In Active" },
                          ]}
                          isClearable={true}
                        />
                        <label className="select-box-label">Status</label>
                        {errMsgStatus}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionprice"
                  aria-expanded="false"
                >
                  Prices
                </button>
              </h2>

              <div
                id="accordionprice"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgProPrice !== "" &&
                            errMsgProPrice !== false &&
                            errMsgProPrice !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="productPrice"
                          value={fields.productPrice}
                          {...$field("productPrice", (e) =>
                            onChange("productPrice", e.target.value)
                          )}
                        />
                        <label htmlFor="productPrice">
                          Product Price <span className="error">*</span>
                        </label>
                        {errMsgProPrice}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgProCost !== "" &&
                            errMsgProCost !== false &&
                            errMsgProCost !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="productCost"
                          value={fields.productCost}
                          {...$field("productCost", (e) =>
                            onChange("productCost", e.target.value)
                          )}
                        />
                        <label htmlFor="productCost">Product Cost</label>
                        {errMsgProCost}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgProSpecialPrice !== "" &&
                            errMsgProSpecialPrice !== false &&
                            errMsgProSpecialPrice !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="productSpecialPrice"
                          value={fields.productSpecialPrice}
                          {...$field("productSpecialPrice", (e) =>
                            onChange("productSpecialPrice", e.target.value)
                          )}
                        />
                        <label htmlFor="productSpecialPrice">Special Price</label>
                        {errMsgProSpecialPrice}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4 custm-date-box">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          selected={fields.productSpecialPriceStart}
                          minDate={new Date()}
                          dateFormat="dd/MM/yyyy"
                          onChange={this.handleChange.bind(
                            this,
                            "productSpecialPriceStart"
                          )}
                        />
                        <label className="select-box-label">
                          Special Price From Date
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4 custm-date-box">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          selected={fields.productSpecialPriceEnd}
                          minDate={new Date()}
                          dateFormat="dd/MM/yyyy"
                          onChange={this.handleChange.bind(
                            this,
                            "productSpecialPriceEnd"
                          )}
                        />
                        <label className="select-box-label">
                          Special Price To Date
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionstock"
                  aria-expanded="false"
                >
                  Stock
                </button>
              </h2>

              <div
                id="accordionstock"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  {console.log(fields.productStock, 'fields.productStockfields.productStock')}
                    {fields.productOutletID.length > 0 && (
                      fields.productOutletID.map((item, index)=> {
                        const stockDetails =  fields.productStock !== "" && Array.isArray(fields.productStock)
                        ? fields.productStock.reduce((acc, curr) => {
                            if (acc) return acc; // already found
                            return curr?.outletID === item.value ? curr : null;
                          }, null)
                        : null;
                        
                       /*  
                        (fields.productStock!=="")?fields.productStock.reduce((acc) => {
                          console.log(item.value, acc?.outletID ?? '', 'item.value')
                          const stockOutlet = acc?.outletID ?? '';
                          if(stockOutlet===item.value) {
                            return acc;
                          }
                        }, ''):''; */
                        console.log(stockDetails, 'stockDetails')
                        return(<div className="row g-3" key={index}>
                          <div className="col-md-3">
                            {item.label}
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline mb-4">
                                <input
                                  type="text"
                                  className={
                                    errMsgProStock !== "" &&
                                    errMsgProStock !== false &&
                                    errMsgProStock !== undefined
                                      ? "form-control is-invalid"
                                      : "form-control"
                                  }
                                  name={`stock-${index}`}
                                  value={stockDetails?.stock ?? ''}
                                  onChange={this.handleChangeStockTxt.bind(this, item.value, 'stock')}
                                />
                                <label htmlFor={`stock-${index}`}>
                                  Available Stock <span className="error">*</span>
                                </label>
                              </div>
                            </div>
                          <div className="col-md-3">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`lowStockAlert-${index}`}
                                checked={stockDetails?.lowStockAlert ?? false}
                                onChange={this.handleChangeStockTxt.bind(this, item.value, 'lowStockAlert')}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`lowStockAlert-${index}`}
                              >
                                Low Stock Alert Mail
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`outofStock-${index}`}
                                checked={stockDetails?.outofStock ?? false}
                                onChange={this.handleChangeStockTxt.bind(this, item.value, 'outofStock')}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`outofStock-${index}`}
                              >
                                Set Out of Stock
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="text"
                                className="form-control"
                                name={`lowStock-${index}`}
                                value={stockDetails?.lowStock ?? ''}
                                onChange={this.handleChangeStockTxt.bind(this, item.value, 'lowStock')}
                              />
                              <label htmlFor={`lowStock-${index}`}>Minimum Stock</label>
                            </div>
                          </div>
                        </div>
                        );
                      })
                    )}
                </div>
              </div>
            </div>
            {fields.productType?.value === 3 && (
              <div className="accordion-item ">
                <h2 className="accordion-header">
                  <button
                    type="button"
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordionvoucher"
                    aria-expanded="false"
                  >
                    Voucher Details
                  </button>
                </h2>

                <div
                  id="accordionvoucher"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionStyle1"
                >
                  <div className="accordion-body">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline custm-select-box mb-4">
                          <Select
                            value={fields.productVoucherType}
                            onChange={this.handleSelectChange.bind(
                              this,
                              "productVoucherType"
                            )}
                            placeholder="Select Voucher Type"
                            options={[
                              { value: "c", label: "Cash Voucher" },
                              { value: "f", label: "Food Voucher" },
                            ]}
                            isClearable={true}
                          />
                          <label className="select-box-label">
                            Voucher Type
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4 custm-date-box">
                          <DatePicker
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            selected={fields.productVoucherExpiryDate}
                            minDate={new Date()}
                            dateFormat="dd/MM/yyyy"
                            onChange={this.handleChange.bind(
                              this,
                              "productVoucherExpiryDate"
                            )}
                          />
                          <label className="select-box-label">
                            Voucher Expiry Date
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="productVoucherExpiryDays"
                            value={fields.productVoucherExpiryDays}
                            {...$field("productVoucherExpiryDays", (e) =>
                              onChange("productVoucherExpiryDays", e.target.value)
                            )}
                          />
                          <label htmlFor="productVoucherExpiryDays">
                            Number Of Dates <span className="error">*</span>
                          </label>
                        </div>
                      </div>
                        {fields.productVoucherType?.value === "c" && (
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="text"
                                className="form-control"
                                name="productVoucherPoints"
                                value={fields.productVoucherPoints}
                                {...$field("productVoucherPoints", (e) =>
                                  onChange(
                                    "productVoucherPoints",
                                    e.target.value
                                  )
                                )}
                                id="productVoucherPoints"
                              />
                              <label htmlFor="productVoucherPoints">
                                Voucher Points{" "}
                                <span className="error">*</span>
                              </label>
                            </div>
                          </div>
                        )}

                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="productVoucherIncreaseQTY"
                            value={fields.productVoucherIncreaseQTY}
                            {...$field("productVoucherIncreaseQTY", (e) =>
                              onChange("productVoucherIncreaseQTY", e.target.value)
                            )}
                          />
                          <label htmlFor="productVoucherIncreaseQTY">
                            Number Of Item
                          </label>
                        </div>
                      </div>

                      {fields.productVoucherType?.value === "f" && (
                        <>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline custm-select-box mb-4">
                              <Select
                                value={fields.productVoucherReedmedAvailability}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "productVoucherReedmedAvailability"
                                )}
                                isMulti
                                placeholder="Select Food Voucher Redeem Availability"
                                options={this.props.availabiltyList.map(
                                  (item) => {
                                    return {
                                      value: item.av_id,
                                      label: item.av_name,
                                    };
                                  }
                                )}
                                isClearable={true}
                              />
                              <label className="select-box-label">
                                Food Voucher Redeem Availability
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline custm-select-box mb-4">
                              <Select
                                value={fields.productVoucherFoodOption}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "productVoucherFoodOption"
                                )}
                                placeholder="Select Food Voucher Option"
                                options={[
                                  { value: "1", label: "Normal" },
                                  { value: "2", label: "Discount" },
                                ]}
                                isClearable={true}
                              />
                              <label className="select-box-label">
                                Food Voucher Option
                              </label>
                            </div>
                          </div>
                          {fields.productVoucherFoodOption !== "" && (
                            <>
                              {fields.productVoucherFoodOption.value === "2" && (
                                <>
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline custm-select-box mb-4">
                                      <Select
                                        value={
                                          fields.productVoucherFoodDiscountType
                                        }
                                        onChange={this.handleSelectChange.bind(
                                          this,
                                          "productVoucherFoodDiscountType"
                                        )}
                                        placeholder="Select Food Voucher Discount Type"
                                        options={[
                                          { value: "1", label: "Fixed" },
                                          {
                                            value: "2",
                                            label: "Percentage",
                                          },
                                        ]}
                                        isClearable={true}
                                      />
                                      <label className="select-box-label">
                                        Food Voucher Discount Type
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline mb-4">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="productFoodVoucherDiscValue"
                                        value={fields.productFoodVoucherDiscValue}
                                        {...$field(
                                          "productFoodVoucherDiscValue",
                                          (e) =>
                                            onChange(
                                              "productFoodVoucherDiscValue",
                                              e.target.value
                                            )
                                        )}
                                      />
                                      <label htmlFor="productFoodVoucherDiscValue">
                                        Food Voucher Discount Value
                                      </label>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline custm-select-box mb-4">
                              <Select
                                value={fields.productVoucherFreeProduct}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "productVoucherFreeProduct"
                                )}
                                placeholder={
                                  "Select Free Product / Voucher"
                                }
                                options={this.props.simpleProducts}
                                isClearable={true}
                              />
                              <label className="select-box-label">
                                Free Product / Voucher
                              </label>
                            </div>
                          </div>

                          {fields.productVoucherFoodOption !== "" && (
                            <>
                              {fields.productVoucherFoodOption.value === "2" && (
                                <div className="col-md-12">
                                  <div className="form-floating form-floating-outline custm-select-box mb-4">
                                    <Select
                                      value={
                                        fields.productVoucherValidateProducts
                                      }
                                      onChange={this.handleSelectChange.bind(
                                        this,
                                        "productVoucherValidateProducts"
                                      )}
                                      isMulti
                                      placeholder={
                                        "Select Included Products"
                                      }
                                      options={this.props.simpleProducts}
                                      isClearable={true}
                                    />
                                    <label className="select-box-label">
                                      Included Products
                                    </label>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordiongallery"
                  aria-expanded="false"
                >
                  Gallery
                </button>
              </h2>

              <div
                id="accordiongallery"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainer">
                          <label htmlFor="formFile" className="form-label">
                            Thumbnail Image
                          </label>
                          <br />
                          <span>Recommended Size 250 X 120 PX</span>
                          <input
                            className="form-control"
                            type="file"
                            id="productThumbnail"
                            onChange={(event) => {
                              this.uplaodFiles("productThumbnail", event);
                              return false;
                            }}
                          />
                        </div>
                      </div>
                      {fields.productThumbnail !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="ImageDetails">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productThumbnail} />
                            </div>
                          </div>
                          <a
                            className="dz-remove"
                            href={() => false}
                            onClick={this.removeImage.bind(
                              this,
                              fields.productThumbnail,
                              "productThumbnail"
                            )}
                          >
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="col-md-12">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="LargeImageContainer">
                          <label htmlFor="formFile" className="form-label">
                            Zoom Or Large Image
                          </label>
                          <br />
                          <span>Recommended Size 1000 X 1000 PX</span>
                          <input
                            className="form-control"
                            type="file"
                            id="productLargeImage"
                            onChange={(event) => {
                              this.uplaodFiles("productLargeImage", event);
                              return false;
                            }}
                          />
                        </div>
                      </div>
                      {fields.productLargeImage !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="LargeImageDetails">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productLargeImage} />
                            </div>
                          </div>
                          <a
                            className="dz-remove"
                            href={() => false}
                            onClick={this.removeImage.bind(
                              this,
                              fields.productLargeImage,
                              "productLargeImage"
                            )}
                          >
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>

                    
                    <div className="col-md-12">
                      <div className="card mb-4">
                        <h5 className="card-header">Gallery Images</h5>
                        <div className="card-body">
                          <div className="dz-message needsclick">
                            Drop files here or click to upload
                            <span className="note needsclick">
                              (This is just a demo dropzone. Selected files are{" "}
                              <strong>not</strong> actually uploaded.)
                            </span>
                          </div>
                          <div className="fallback">
                            <input
                              name="file"
                              type="file"
                              id="gallery_images"
                              onChange={(event) => {
                                this.uplaodGalleryImage(event);
                                return false;
                              }}
                            />
                          </div>
                          {fields.productGallery.length > 0 &&
                            fields.productGallery.map((item, index) => {
                              return (
                                <div
                                  className="dz-preview dz-processing dz-image-preview dz-success dz-complete"
                                  key={index}
                                  id={`galleryDetails_${index}`}
                                >
                                  <div className="dz-details">
                                    <div className="dz-thumbnail">
                                      <img alt="" src={item} />
                                    </div>
                                  </div>
                                  <a
                                    className="dz-remove"
                                    href={() => false}
                                    onClick={this.removeGalleryImage.bind(
                                      this,
                                      item,
                                      index
                                    )}
                                  >
                                    Remove file
                                  </a>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordiontimeavailability"
                  aria-expanded="false"
                >
                  Time Availability
                </button>
              </h2>

              <div
                id="accordiontimeavailability"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productTimeAvailabilityErrorInfo"
                          value={fields.productTimeAvailabilityErrorInfo}
                          {...$field("productTimeAvailabilityErrorInfo", (e) =>
                            onChange("productTimeAvailabilityErrorInfo", e.target.value)
                          )}
                        />
                        <label htmlFor="productTimeAvailabilityErrorInfo">
                          Product Availability Errorinfo
                        </label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="pro_advancedaytime_availability_div">
                        {fields.productTimeAvailability.map((item, index) => {
                          return (
                            <div key={index}>
                              <div className="pro_current_daydatewise_title">
                                {item.title}
                              </div>

                              <div className="col-md-12">
                                <div className="pro_daydatewise_availability">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="pro_daywise_availability">
                                        <div className="pro_daywise_availability_main">
                                          <div className="pro_current_daywise_title">
                                            Day based availability
                                            <span
                                              className="mdi mdi-plus-box text-end"
                                              onClick={this.addNew.bind(
                                                this,
                                                index,
                                                "daybased"
                                              )}
                                            ></span>
                                          </div>
                                          {item.data[0].daybased.map(
                                            (dayItem, dayIndex) => {
                                              var selectedday =
                                                dayItem.day !== "" &&
                                                dayItem.day !== null
                                                  ? dayItem.day.split(",")
                                                  : [];
                                              return (
                                                <div
                                                  className="daywiseitem_text_div mb-2"
                                                  key={dayIndex}
                                                >
                                                  {item.data[0].daybased
                                                    .length > 1 && (
                                                    <div className="text-end">
                                                      {" "}
                                                      <span
                                                        className="mdi mdi-trash-can-outline"
                                                        onClick={this.deleteAvailSlot.bind(
                                                          this,
                                                          index,
                                                          dayIndex,
                                                          "daybased"
                                                        )}
                                                      ></span>
                                                    </div>
                                                  )}
                                                  <div className="form-group daywiseitem_form_group">
                                                    {dayList.map(
                                                      (day, dayListIndex) => {
                                                        return (
                                                          <div
                                                            className="form-check form-check-inline mt-3"
                                                            key={dayListIndex}
                                                          >
                                                            <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              id={
                                                                "day_" +
                                                                dayIndex +
                                                                "_" +
                                                                dayListIndex +
                                                                "_" +
                                                                day
                                                              }
                                                              value={day.toLowerCase()}
                                                              checked={
                                                                selectedday.indexOf(
                                                                  day.toLowerCase()
                                                                ) >= 0
                                                                  ? true
                                                                  : false
                                                              }
                                                              onChange={this.handleChangeCheckBox.bind(
                                                                this,
                                                                item.type,
                                                                dayIndex,
                                                                "daybased",
                                                                "day"
                                                              )}
                                                            />
                                                            <label
                                                              className="form-check-label"
                                                              htmlFor={
                                                                "day_" +
                                                                dayIndex +
                                                                "_" +
                                                                dayListIndex +
                                                                "_" +
                                                                day
                                                              }
                                                            >
                                                              {day}
                                                            </label>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>

                                                  <div className="row">
                                                    <div className="col-md-3">
                                                      <div className="form-floating-outline mt-2 custm-date-box">
                                                        <DatePicker
                                                          className="form-control"
                                                          showTimeSelect
                                                          showTimeSelectOnly
                                                          timeIntervals={15}
                                                          selected={
                                                            dayItem.from !==
                                                              "" &&
                                                            dayItem.from !==
                                                              null
                                                              ? new Date(
                                                                  dayItem.from
                                                                )
                                                              : ""
                                                          }
                                                          timeCaption="Time"
                                                          dateFormat="h:mm aa"
                                                          onChange={this.handleChangeAvailDate.bind(
                                                            this,
                                                            item.type,
                                                            dayIndex,
                                                            "daybased",
                                                            "fromtime"
                                                          )}
                                                        />
                                                        <label className="select-box-label">
                                                          From
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                      <div className="form-floating-outline mt-2 custm-date-box">
                                                        <DatePicker
                                                          className="form-control"
                                                          showTimeSelect
                                                          showTimeSelectOnly
                                                          timeIntervals={15}
                                                          timeCaption="Time"
                                                          dateFormat="h:mm aa"
                                                          selected={
                                                            dayItem.to !== "" &&
                                                            dayItem.to !== null
                                                              ? new Date(
                                                                  dayItem.to
                                                                )
                                                              : ""
                                                          }
                                                          onChange={this.handleChangeAvailDate.bind(
                                                            this,
                                                            item.type,
                                                            dayIndex,
                                                            "daybased",
                                                            "totime"
                                                          )}
                                                        />
                                                        <label className="select-box-label">
                                                          To
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                      <div className="form-floating-outline mt-2">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={dayItem.stock}
                                                          onChange={this.handleChangeText.bind(
                                                            this,
                                                            item.type,
                                                            dayIndex,
                                                            "daybased",
                                                            "stock"
                                                          )}
                                                          placeholder="Stock"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                      <div className="form-check form-check-inline mt-3">
                                                        <input
                                                          className="form-check-input"
                                                          type="checkbox"
                                                          id={
                                                            "day_" +
                                                            index +
                                                            "_" +
                                                            dayIndex +
                                                            "_validate"
                                                          }
                                                          value="Yes"
                                                          checked={
                                                            dayItem.validate ===
                                                            "Yes"
                                                              ? true
                                                              : false
                                                          }
                                                          onChange={this.handleChangeCheckBox.bind(
                                                            this,
                                                            item.type,
                                                            dayIndex,
                                                            "daybased",
                                                            "validate"
                                                          )}
                                                        />
                                                        <label
                                                          className="form-check-label"
                                                          htmlFor={
                                                            "day_" +
                                                            index +
                                                            "_" +
                                                            dayIndex +
                                                            "_validate"
                                                          }
                                                        >
                                                          Validate
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="pro_datewise_availability">
                                        <div className="pro_datewise_availability_main">
                                          <input
                                            type="hidden"
                                            name="datewise_avbl_count"
                                            id="datewise_avbl_count"
                                            className="datewise_avbl_count"
                                            value="0"
                                          />
                                          <div className="pro_current_datewise_title">
                                            Date based availability
                                            <span
                                              className="mdi mdi-plus-box text-end"
                                              onClick={this.addNew.bind(
                                                this,
                                                index,
                                                "datebased"
                                              )}
                                            ></span>
                                          </div>
                                          {item.data[1].datebased.map(
                                            (dateItem, dateIndex) => {
                                              return (
                                                <div
                                                  className="daywiseitem_text_div mb-2"
                                                  key={dateIndex}
                                                >
                                                  {item.data[1].datebased
                                                    .length > 1 && (
                                                    <div className="text-end">
                                                      {" "}
                                                      <span
                                                        className="mdi mdi-trash-can-outline "
                                                        onClick={this.deleteAvailSlot.bind(
                                                          this,
                                                          index,
                                                          dateIndex,
                                                          "datebased"
                                                        )}
                                                      ></span>
                                                    </div>
                                                  )}
                                                  <div className="row">
                                                    <div className="col-md-4">
                                                      <div className="form-floating-outline mt-3 custm-date-box">
                                                        <DatePicker
                                                          peekNextMonth
                                                          showMonthDropdown
                                                          showYearDropdown
                                                          showTimeSelect
                                                          dropdownMode="select"
                                                          className="form-control"
                                                          minDate={new Date()}
                                                          dateFormat="d-MM-yyyy h:mm aa"
                                                          selected={
                                                            dateItem.from !==
                                                              "" &&
                                                            dateItem.from !==
                                                              null
                                                              ? new Date(
                                                                  dateItem.from
                                                                )
                                                              : ""
                                                          }
                                                          onChange={this.handleChangeAvailDate.bind(
                                                            this,
                                                            item.type,
                                                            dateIndex,
                                                            "datebased",
                                                            "fromdate"
                                                          )}
                                                        />
                                                        <label className="select-box-label">
                                                          From
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      <div className="form-floating-outline mt-3 custm-date-box">
                                                        <DatePicker
                                                          peekNextMonth
                                                          showMonthDropdown
                                                          showYearDropdown
                                                          showTimeSelect
                                                          dropdownMode="select"
                                                          className="form-control"
                                                          dateFormat="d-MM-yyyy h:mm aa"
                                                          minDate={
                                                            dateItem.from !==
                                                              "" &&
                                                            dateItem.from !==
                                                              null
                                                              ? new Date(
                                                                  dateItem.from
                                                                )
                                                              : new Date()
                                                          }
                                                          selected={
                                                            dateItem.to !==
                                                              "" &&
                                                            dateItem.to !== null
                                                              ? new Date(
                                                                  dateItem.to
                                                                )
                                                              : ""
                                                          }
                                                          onChange={this.handleChangeAvailDate.bind(
                                                            this,
                                                            item.type,
                                                            dateIndex,
                                                            "datebased",
                                                            "todate"
                                                          )}
                                                        />
                                                        <label className="select-box-label">
                                                          To
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                      <div className="form-floating-outline mt-3">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={dateItem.stock}
                                                          onChange={this.handleChangeText.bind(
                                                            this,
                                                            item.type,
                                                            dateIndex,
                                                            "datebased",
                                                            "stock"
                                                          )}
                                                          placeholder="Stock"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                      <div className="form-check form-check-inline mt-4">
                                                        <input
                                                          className="form-check-input"
                                                          type="checkbox"
                                                          id={
                                                            "date_" +
                                                            index +
                                                            "_" +
                                                            dateIndex +
                                                            "_validate"
                                                          }
                                                          value="Yes"
                                                          checked={
                                                            dateItem.validate ===
                                                            "Yes"
                                                              ? true
                                                              : false
                                                          }
                                                          onChange={this.handleChangeCheckBox.bind(
                                                            this,
                                                            item.type,
                                                            dateIndex,
                                                            "datebased",
                                                            "validate"
                                                          )}
                                                        />
                                                        <label
                                                          className="form-check-label"
                                                          htmlFor={
                                                            "date_" +
                                                            index +
                                                            "_" +
                                                            dateIndex +
                                                            "_validate"
                                                          }
                                                        >
                                                          Validate
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {productType === 2 && (
              <div className="accordion-item ">
                <h2 className="accordion-header">
                  <button
                    type="button"
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordioncombo-1"
                    aria-expanded="false"
                  >
                    Combo Setup
                  </button>
                </h2>

                <div
                  id="accordioncombo-1"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionStyle1"
                >
                  <div className="accordion-body">
                    <div className="col-md-12 text-end mb-3">
                      <a
                        href={() => false}
                        onClick={this.addNewCombo.bind(this)}
                      >
                        <button
                          type="button"
                          className="btn btn-outline-primary waves-effect"
                        >
                          Add New
                        </button>
                      </a>
                    </div>
                    <div className="form-check form-check-inline mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={"productApplyMinMaxSelect"}
                        defaultChecked={fields.productApplyMinMaxSelect}
                        onChange={this.handleChangeCheck.bind(
                          this,
                          "productApplyMinMaxSelect"
                        )}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={"productApplyMinMaxSelect"}
                      >
                        Apply Minimum, Maximum Setup
                      </label>
                    </div>

                    {fields.productComboSet.length > 0 &&
                      fields.productComboSet.map((item, index) => {
                        return (
                          <div
                            className="card mb-4 border-2 border-primary mb-3"
                            key={index}
                          >
                            <div className="card-body">
                              {fields.productComboSet.length > 1 && (
                                <div className="text-end">
                                  <a
                                    href={() => false}
                                    onClick={this.removeComboSet.bind(
                                      this,
                                      index
                                    )}
                                  >
                                    <span className="mdi mdi-trash-can-outline"></span>
                                  </a>
                                </div>
                              )}
                              <h4 className="card-title">
                                {item.combo_name !== ""
                                  ? item.combo_name
                                  : "Combo Set " + (parseInt(index) + 1)}
                              </h4>
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      value={item.combo_name}
                                      className="form-control"
                                      onChange={this.handleChangeComboTxt.bind(
                                        this,
                                        index,
                                        "combo_name"
                                      )}
                                    />
                                    <label htmlFor="combo_name">
                                      Product Set Name{" "}
                                      <span className="error">*</span>
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-floating form-floating-outline custm-select-box mb-4">
                                    <Select
                                      value={item.products}
                                      onChange={this.handleChangeComboSelect.bind(
                                        this,
                                        index,
                                        "products"
                                      )}
                                      isMulti
                                      placeholder={"Combo Products"}
                                      options={this.props.simpleProducts}
                                      isClearable={true}
                                    />
                                    <label className="select-box-label">
                                      Combo Products
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-floating form-floating-outline custm-select-box mb-4">
                                    <Select
                                      value={item.combogroup}
                                      onChange={this.handleChangeComboSelect.bind(
                                        this,
                                        index,
                                        "combogroup"
                                      )}
                                      isMulti
                                      placeholder={
                                        "Select Combo Product Groups"
                                      }
                                      options={this.props.prdouctGroupList}
                                      isClearable={true}
                                    />
                                    <label className="select-box-label">
                                      Combo Product Groups
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline custm-select-box mb-4">
                                    <Select
                                      value={item.defaultproduct}
                                      onChange={this.handleChangeComboSelect.bind(
                                        this,
                                        index,
                                        "defaultproduct"
                                      )}
                                      placeholder={"Select Default Products"}
                                      options={this.props.simpleProducts}
                                      isClearable={true}
                                    />
                                    <label className="select-box-label">
                                      Default Products
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={item.piecescount}
                                      onChange={this.handleChangeComboTxt.bind(
                                        this,
                                        index,
                                        "piecescount"
                                      )}
                                    />
                                    <label htmlFor="piecescount">
                                      Pieces Count
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="min_select"
                                      value={item.min_select}
                                      onChange={this.handleChangeComboTxt.bind(
                                        this,
                                        index,
                                        "min_select"
                                      )}
                                    />
                                    <label htmlFor="min_select">
                                      Minimum Select
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="max_select"
                                      value={item.max_select}
                                      onChange={this.handleChangeComboTxt.bind(
                                        this,
                                        index,
                                        "max_select"
                                      )}
                                    />
                                    <label htmlFor="max_select">
                                      Maximum Select
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="sequence"
                                      value={item.sequence}
                                      onChange={this.handleChangeComboTxt.bind(
                                        this,
                                        index,
                                        "sequence"
                                      )}
                                    />
                                    <label htmlFor="sequence">Sort Order</label>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-check form-check-inline mt-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={"apply_price_" + index}
                                      defaultChecked={item.apply_price}
                                      onChange={this.handleChangeComboCheck.bind(
                                        this,
                                        index,
                                        "apply_price"
                                      )}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={"apply_price_" + index}
                                    >
                                      Apply Price
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline mt-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={"apply_modifier_" + index}
                                      defaultChecked={item.apply_modifier}
                                      onChange={this.handleChangeComboCheck.bind(
                                        this,
                                        index,
                                        "apply_modifier"
                                      )}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={"apply_modifier_" + index}
                                    >
                                      Single Select
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline mt-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={"multipleselection_apply" + index}
                                      defaultChecked={item.multipleselection_apply}
                                      onChange={this.handleChangeComboCheck.bind(
                                        this,
                                        index,
                                        "multipleselection_apply"
                                      )}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={
                                        "multipleselection_apply" + index
                                      }
                                    >
                                      Multiple Selections
                                    </label>
                                  </div>
                                  {/* <div className="form-check form-check-inline mt-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={"single_selection_" + index}
                                      defaultChecked={item.single_selection}
                                      onChange={this.handleChangeComboCheck.bind(
                                        this,
                                        index,
                                        "single_selection"
                                      )}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={"single_selection_" + index}
                                    >
                                      Single Select
                                    </label>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div className="col-md-12 text-end mb-3">
                      <a
                        href={() => false}
                        onClick={this.addNewCombo.bind(this)}
                      >
                        <button
                          type="button"
                          className="btn btn-outline-primary waves-effect"
                        >
                          Add New
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            className="pt-1 pb-4 pr-2 text-end"
            style={{ paddingRight: "20px" }}
          >
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
